document.addEventListener("DOMContentLoaded", () => {
    const buttons = document.querySelectorAll('.c-menu--campaign__button');

    buttons.forEach(function (button) {
        button.addEventListener('click', function(this: HTMLElement, event: Event) {
            const targetId = this.getAttribute('data-target');

            if (targetId) {
                const menu = document.getElementById(targetId);

                if (menu) {
                    menu.classList.toggle('is-open');

                    let closestUsaNav = menu.closest('.c-menu--campaign__nav');

                    if (closestUsaNav) {
                        closestUsaNav.classList.toggle('is-visible');
                    }
                }

                // Find the campaign-usa-menu-btn within the clicked button
                const usaMenu = this.querySelector('.campaign-usa-menu-btn');

                if (usaMenu) {
                    usaMenu.classList.toggle('close');
                }
            }

        });
    });
});
